'use strict';

require("core-js/modules/es6.function.bind");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactJss = require('react-jss');

var _reactJss2 = _interopRequireDefault(_reactJss);

var _clsx = require('clsx');

var _clsx2 = _interopRequireDefault(_clsx);

var _Icon = require('../Icon/Icon.js');

var _Icon2 = _interopRequireDefault(_Icon);

var _Avatar = require('../Avatar/Avatar.js');

var _Avatar2 = _interopRequireDefault(_Avatar);

var _Label = require('../Label/Label.js');

var _Label2 = _interopRequireDefault(_Label);

var _Chip = require('./Chip.style');

var _Chip2 = _interopRequireDefault(_Chip);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var Chip = (_dec = (0, _reactJss2["default"])(_Chip2["default"]), _dec(_class = function (_PureComponent) {
  (0, _inherits3["default"])(Chip, _PureComponent);

  function Chip(props) {
    (0, _classCallCheck3["default"])(this, Chip);

    var _this = (0, _possibleConstructorReturn3["default"])(this, (Chip.__proto__ || (0, _getPrototypeOf2["default"])(Chip)).call(this, props));

    _this.closeClick = _this.closeClick.bind(_this);
    return _this;
  }

  (0, _createClass3["default"])(Chip, [{
    key: 'closeClick',
    value: function closeClick(e) {
      e.stopPropagation();
      var closeClick = this.props.closeClick;
      closeClick();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          id = _props.id,
          classes = _props.classes,
          className = _props.className,
          label = _props.label,
          src = _props.src,
          icon = _props.icon,
          closeIcon = _props.closeIcon,
          onClick = _props.onClick,
          onMouseEnter = _props.onMouseEnter,
          onMouseLeave = _props.onMouseLeave,
          type = _props.type,
          size = _props.size,
          fontSize = _props.fontSize,
          fontWeight = _props.fontWeight,
          children = _props.children;
      var chipClasses = (0, _clsx2["default"])(className, classes.chip, classes[type], classes[size]);
      var hasSrc = src && src.length;
      return _react2["default"].createElement('div', {
        id: id,
        className: chipClasses,
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
      }, hasSrc && _react2["default"].createElement(_Avatar2["default"], {
        size: 'medium',
        src: src,
        className: (0, _clsx2["default"])(classes.avatar)
      }), icon && !hasSrc && _react2["default"].createElement(_Icon2["default"], {
        type: icon,
        size: 'small',
        className: (0, _clsx2["default"])(classes.icon)
      }), label && _react2["default"].createElement(_Label2["default"], {
        fontSize: fontSize,
        fontWeight: fontWeight,
        value: label,
        textColor: 'inherit',
        className: (0, _clsx2["default"])(classes.label)
      }), children, closeIcon && _react2["default"].createElement(_Icon2["default"], {
        type: 'close',
        size: 'micro',
        color: 'currentColor',
        className: (0, _clsx2["default"])(classes.closeIcon),
        onClick: this.closeClick
      }));
    }
  }]);
  return Chip;
}(_react.PureComponent)) || _class);
Chip.defaultProps = {
  closeIcon: true,
  closeClick: function closeClick() {},
  onMouseEnter: function onMouseEnter() {},
  onMouseLeave: function onMouseLeave() {},
  size: 'medium',
  fontSize: 'medium',
  fontWeight: 'semibold',
  type: 'rounded',
  children: null
};
Chip.propTypes = {
  classes: _propTypes2["default"].object,

  /** additional external class name */
  className: _propTypes2["default"].string,

  /** type */
  type: _propTypes2["default"].oneOf(['rounded', 'rectangular']),

  /** size */
  size: _propTypes2["default"].oneOf(['small', 'medium', 'large']),

  /** label font size */
  fontSize: _propTypes2["default"].oneOf(['small', 'medium']),

  /** label weight */
  fontWeight: _propTypes2["default"].oneOf(['normal', 'semibold']),

  /** label text */
  label: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].number]),

  /** element id */
  id: _propTypes2["default"].oneOfType([_propTypes2["default"].string, _propTypes2["default"].number]),

  /** avatar src */
  src: _propTypes2["default"].string,

  /** icon chip */
  icon: _propTypes2["default"].string,

  /** is close icon */
  closeIcon: _propTypes2["default"].bool,

  /** callback click chip */
  onClick: _propTypes2["default"].func,

  /** callback MouseEnter chip */
  onMouseEnter: _propTypes2["default"].func,

  /** callback MouseLeave chip */
  onMouseLeave: _propTypes2["default"].func,

  /** callback click close icon */
  closeClick: _propTypes2["default"].func,

  /** child components */
  children: _propTypes2["default"].node
};
exports["default"] = Chip;